import { Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { getAmenitiesIcon, getReadableAmenitiesName } from './AmenitiesMapping';
import React from 'react';

export const motorbikeSpecificProperties = [
    'adjustableSeats',
    'helmet',
    'gloves',
];
export const carSpecificProperties = [
    'ac',
    'keylessEntry',
    'sunroof',
    'laneAssist',
    'autoPark',
    'powerSeats',
    'remoteStart',
    'wirelessPhoneCharger',
    'rearEntertainmentSystem',
];

export default function AmenitiesComponent(assetInfo: any) {
    const theme = useTheme();
    const value = assetInfo?.amenities;

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isIpad = useMediaQuery(theme.breakpoints.down('md'));
    return (
        <Grid
            container
            direction='row'
            spacing={1}
            sx={{
                width: isIpad ? '%' : '100%',
            }}
        >
            {(Object.keys(value) as string[])
                ?.filter((key) => value[key] === false || value[key] === true)
                .filter(
                    (key) =>
                        key !== 'dropoffLocationSameAsPickup' &&
                        key !== 'dropoffUsesNirovision' &&
                        key !== 'petsAllowed' &&
                        key !== 'smokingAllowed',
                )
                .filter((key) => {
                    if (value.subType === 'car') {
                        return !motorbikeSpecificProperties.includes(key);
                    } else if (value.subType === 'motorbike') {
                        return !carSpecificProperties.includes(key);
                    }
                    return true;
                })
                .map((key: any) => (
                    <Grid
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            height: '50px',
                            alignItems: 'center',
                            justifyContent: 'flex-start',
                            opacity: value[key] ? 1 : 0.3,
                        }}
                        item
                        xs={6}
                        sm={6}
                        md={6}
                        lg={3}
                        xl={3}
                        key={key}
                    >
                        <Grid
                            sx={{
                                width: '20%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            {getAmenitiesIcon('icon', key)}
                        </Grid>
                        <Grid
                            sx={{
                                width: '80%',
                                paddingLeft: isMobile
                                    ? '10px'
                                    : isIpad
                                      ? '20px'
                                      : '10px',
                                textDecoration: value[key]
                                    ? 'none'
                                    : 'line-through',
                                color: 'text.primary',
                                display: 'flex',
                                alignItems: 'center',
                                textShadow: value[key]
                                    ? '1px 1px 2px rgba(0,0,0,0.3)'
                                    : 'none',
                            }}
                        >
                            <Typography variant='body1'>
                                {getReadableAmenitiesName('type', key)}
                            </Typography>
                        </Grid>
                    </Grid>
                ))}
        </Grid>
    );
}
